export default __webpack_public_path__ + "static/media/solucao-09.61388514.webp";